export default __webpack_public_path__ + "static/media/safari.93e4ca5d.svg";